import React from "react";
import PageWrapper from "../components/PageWrapper";
import "./css/Contact.css"; // Reuse the same styling
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Terms = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service | GTAFanPage.com</title>
        <meta
          name="description"
          content="Read the Terms of Service for GTAFanPage.com. Learn about user responsibilities, site limitations, and content usage policies."
        />
        <link
          rel="canonical"
          href="https://www.gtafanpage.com/terms-and-conditions"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Terms of Service | GTAFanPage.com" />
        <meta
          property="og:description"
          content="Understand your responsibilities and rights when using GTAFanPage.com. Review our official Terms of Service."
        />
        <meta
          property="og:url"
          content="https://www.gtafanpage.com/terms-and-conditions"
        />
        <meta
          property="og:image"
          content="https://www.gtafanpage.com/og-image.jpg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Terms of Service | GTAFanPage.com"
        />
        <meta
          name="twitter:description"
          content="Review the legal terms that govern your use of GTAFanPage.com. Stay informed on our content rules and liabilities."
        />
        <meta
          name="twitter:image"
          content="https://www.gtafanpage.com/og-image.jpg"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Terms of Service",
            url: "https://www.gtafanpage.com/terms-and-conditions",
            description:
              "Legal terms for using GTAFanPage.com. Includes user rights, disclaimers, and limitations of liability.",
            publisher: {
              "@type": "Organization",
              name: "GTAFanPage",
              url: "https://www.gtafanpage.com",
              logo: {
                "@type": "ImageObject",
                url: "https://www.gtafanpage.com/logo192.png",
              },
            },
          })}
        </script>
      </Helmet>

      <PageWrapper>
        <div className="contact-page-wrapper">
          <div className="contact-card">
            <h2>Terms of Service</h2>
            <p>
              By accessing and using GTAFanPage.com, you agree to comply with
              our Terms of Service. You must be at least 13 years old to use
              this site. Do not engage in illegal activity, impersonation, or
              abuse of our services.
            </p>
            <p>
              We reserve the right to remove content, restrict accounts, or
              terminate access for users who violate these Terms. GTAFanPage.com
              is a fan-operated site and is not affiliated with Rockstar Games
              or Take-Two Interactive.
            </p>
            <p>
              Your use of the site is at your own risk. We do not guarantee
              uninterrupted access, nor are we liable for any damages resulting
              from use.
            </p>
            <p>
              These terms may be updated from time to time. Continued use of the
              site after changes are posted constitutes your acceptance of those
              changes.
            </p>
            <p>
              All content on this website is provided for informational and
              entertainment purposes only. GTAFanPage.com is an independent fan
              project and is not affiliated with, endorsed, or sponsored by
              Rockstar Games or Take-Two Interactive.
            </p>
            <p>
              For any questions or inquiries, please visit our{" "}
              <Link to="/contact" className="contact-link">
                Contact Us
              </Link>{" "}
              to send us a message.
            </p>
          </div>
        </div>
      </PageWrapper>
    </>
  );
};

export default Terms;
